var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"account_container"}},[_c('div',{class:{'hideLeftMenu': _vm.sizeScreen < 1300},attrs:{"id":"account-sitebar"}},[_c('AccountSiteBar')],1),_c('div',{class:{'overScreen': _vm.sizeScreen < 1300},attrs:{"id":"acount_content"}},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }